import { useRef } from 'react';

import TabItem from '@/components/Header/TabItem';
import clsx from 'clsx';

import styles from './index.module.scss';

interface TabInfo {
  route: string;
  title: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

interface TabProp {
  activeRoute: string;
  tabs: TabInfo[];
  type: 'tab1' | 'tab2'; // 아직은 둘 다 모바일용 (각각 depth=1, 2에 대한 탭)
  isSticky?: boolean;
}

const Tab = ({ activeRoute, tabs, type, isSticky }: TabProp) => {
  const tabRef = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   if (!isSticky) {
  //     return;
  //   }

  //   const observer = new IntersectionObserver(
  //     ([e]) => {
  //       if (!tabRef.current) {
  //         return;
  //       }

  //       if (e.isIntersecting) {
  //         tabRef.current.classList.remove(styles.stuck);
  //         return;
  //       }

  //       tabRef.current.classList.add(styles.stuck);
  //     },
  //     {
  //       threshold: 0.5,
  //       rootMargin: '-64px 0px 0px 0px',
  //     },
  //   );

  //   if (tabRef.current) {
  //     observer.observe(tabRef.current);
  //   }

  //   return () => observer.disconnect();
  // }, [isSticky]);

  if (type === 'tab1') {
    return (
      <nav
        ref={tabRef}
        className={clsx(styles.tab1, isSticky && styles.sticky)}
      >
        {tabs.map(({ onClick, route, title }) => {
          const isActive = activeRoute.includes(route);

          return (
            <TabItem
              key={route}
              isActive={isActive}
              size={'small'}
              hasBorder={isActive}
              route={route}
              title={title}
              onClick={onClick}
            />
          );
        })}
      </nav>
    );
  }

  if (type === 'tab2') {
    return (
      <nav
        ref={tabRef}
        className={clsx(styles.tab2, isSticky && styles.sticky)}
      >
        {tabs.map(({ onClick, route, title }) => {
          const isActive = route.includes(activeRoute);

          return (
            <TabItem
              key={route}
              isActive={isActive}
              size={'small'}
              hasBorder
              route={route}
              title={title}
              onClick={onClick}
            />
          );
        })}
      </nav>
    );
  }

  return <></>;
};

export default Tab;
